<template>
  <div>
    <transition name="fade">
      <md-table
        v-if="displayTable"
        :value="windowedErrorCodes"
        :md-sort.sync="currentSort"
        :md-sort-order.sync="currentSortOrder"
        :md-sort-fn="function(a,b){}"
        md-card
      >
        <md-table-empty-state
          md-label="No results"
          :md-description="`We weren't able to find what you were looking for.`"
          class="table"
        >
          <md-button class="md-primary md-raised" @click="openIssue()">Suggest New Error Codes</md-button>
        </md-table-empty-state>

        <md-table-row slot="md-table-row" slot-scope="{ item  }">
          <md-table-cell class="error-cell" md-label="Error Code" md-sort-by="error">
            <span class="text">{{ "0x" + item.error.toString(16).padStart(8, "0") }}</span>
          </md-table-cell>

          <md-table-cell class="name-cell" md-label="Name" md-sort-by="name">
            <span class="text" v-html="highlightMatches(item.name)"></span>

            <md-avatar v-if="item.desc" class="tooltip-avatar">
              <md-icon>info</md-icon>
              <md-tooltip md-direction="right" class="tooltip">{{ item.desc }}</md-tooltip>
            </md-avatar>
          </md-table-cell>

          <md-table-cell class="header-cell" md-label="Header" md-sort-by="header">
            <span class="text">{{ item.header }}</span>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </transition>
  </div>
</template>

<script>
const DEFAULT_WINDOW_SIZE = 25;

let ALL_ERROR_CODES = [];

export default {
  name: "ResultTable",
  props: { filter: String },
  created() {
    import("@/errors.json").then(module => {
      ALL_ERROR_CODES = this.customSort(module.default);
      this.filteredErrorCodes = this.getFilteredErrorCodes();
      this.displayTable = true;
    });
  },
  data: () => ({
    currentSort: "error",
    currentSortOrder: "asc",
    displayWindowsSize: DEFAULT_WINDOW_SIZE,
    displayTable: false,
    filteredErrorCodes: []
  }),
  watch: {
    filter() {
      this.displayWindowsSize = DEFAULT_WINDOW_SIZE;
      this.filteredErrorCodes = this.getFilteredErrorCodes();
    },
    currentSort() {
      this.filteredErrorCodes = this.customSort(this.filteredErrorCodes);
    },
    currentSortOrder() {
      this.filteredErrorCodes = this.customSort(this.filteredErrorCodes);
    }
  },
  computed: {
    windowedErrorCodes: {
      get: function() {
        return this.filteredErrorCodes.slice(0, this.displayWindowsSize);
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("resize", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onScroll);
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    openIssue() {
      window.open(
        "https://github.com/error-guru/error-guru.github.io/issues/new",
        "_blank"
      );
    },
    onScroll() {
      let scrollPosition =
        document.body.scrollTop || document.documentElement.scrollTop;
      let bottomPosition =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      let isBottomReached = scrollPosition > bottomPosition - 20;

      if (isBottomReached) {
        this.displayWindowsSize += 20;
      }
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;

        if (this.currentSortOrder === "desc") {
          [b, a] = [a, b];
        }

        if (sortBy === "error") {
          return a[sortBy] - b[sortBy];
        }

        return a[sortBy].localeCompare(b[sortBy]);
      });
    },
    getFilteredErrorCodes() {
      let filter = this.filter.trim();
      let intFilter = parseInt(filter);

      // Number search case
      if (!isNaN(intFilter)) {
        return ALL_ERROR_CODES.filter(e => e.error == intFilter);
      }

      // Name search case
      return ALL_ERROR_CODES.filter(
        e =>
          e.name.toLowerCase().includes(filter.toLowerCase()) ||
          e.name.toLowerCase().includes(filter.toLowerCase().replace(/ /g, "_"))
      );
    },
    highlightMatches(name) {
      let filter = this.filter
        .toLowerCase()
        .trim()
        .replace(/ /g, "_");
      let highlight = t => `<span class="highlighted">${t}</span>`;
      let output = "";

      if (filter.length == 0 || !isNaN(parseInt(filter))) {
        return name;
      }

      // Highlight all matching `filter` strings
      while (name.length > 0) {
        let position = name.toLowerCase().indexOf(filter);
        if (position === -1) {
          output += name;
          break;
        }

        output += name.substr(0, position);
        output += highlight(name.substr(position, filter.length));
        name = name.substr(position + filter.length);
      }

      return output;
    }
  }
};
</script>

<style>
.highlighted {
  color: red;
}
</style>

<style scoped>
.text {
  font-size: 16px;
  font-family: monospace, "Courier New", Courier;
}

.tooltip-avatar {
  height: 20px;
  vertical-align: top;
}

.tooltip {
  font-size: 14px;
}

.table {
  width: 50px;
}

.error-cell {
  overflow-wrap: break-word;
}

.name-cell {
  overflow-wrap: break-word;
}

.header-cell {
  overflow-wrap: break-word;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>